import { ReactComponent as BullHorn } from "assets/images/v2/bullhorn.svg";
import { ReactComponent as ChevronRight } from "assets/images/v2/chevron-right.svg";
import { PROFILE_COMMUNICATION_PREFERENCES_LABEL, PROFILE_COMMUNICATION_PREFERENCES_SUBTITLE } from "utilities/Constant";
import styles from "./profile-communication.module.scss";

export interface ProfileCommunicationPreferencesProps {
 readonly onClickPreference?: () => void;
}

export default function ProfileCommunicationPreferences({ onClickPreference }: ProfileCommunicationPreferencesProps) {
  return (
    <div className={styles.profileCommunicationWrapper}>
      <button
        type="button"
        onClick={onClickPreference}
        className={styles.profileCommunicationCard}
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClickPreference?.(); }}
      >
        <div className={styles.profileCommunicationTitle}>
          <BullHorn className="icon" />
          <span>{PROFILE_COMMUNICATION_PREFERENCES_LABEL}</span>
        </div>
        <div className={styles.profileCommunicationInfo}>
          <p className="nav-subtitle">{PROFILE_COMMUNICATION_PREFERENCES_SUBTITLE}</p>
          <ChevronRight  className={styles.profileCommunicationRightIcon} aria-label="chevron right" />
        </div>
      </button>
    </div>
  );
}
